<template>
  <!-- 资金划转弹窗 -->
  <c-dialog
    :showFlag="dialogFlag"
    padding-top="24px"
    padding-bottom="24px"
    :confirmText="transferType === 'otc' ? $t('futures.transfer.confirm') : confirmText"
    :confirmLoading="dialogConfirmLoading"
    :confirmDisabled="transferType === 'otc' ? otcDialogConfirmDisabled : dialogConfirmDisabled"
    @close="dialogClose"
    @confirm="transferType === 'otc' ? otcDialogConfirm() : dialogConfirm()"
    :titleText="$t('assets.otcAccount.CapitalTransfer')"
  >
    <section class="transfer-box">
      <!-- 方向 -->
      <ul class="transfer-content" :class="{ reverse: !transferToOther }">
        <li class="transfer-page">
          <!-- 从 -->
          <div class="transfer-page-side gray-cl">
            {{ transferToOther ? $t("assets.otcAccount.from") : $t("assets.otcAccount.to") }}
          </div>
          <div class="transfer-page-name gray-30-bg">{{ $t("assets.index.exchangeAccount") }}</div>
        </li>
        <li class="transfer-icon">
          <svg-icon
            class-name="blue-cl"
            iconClass="transfer-icon"
            @click="setTransferSide"
          ></svg-icon>
        </li>
        <li class="transfer-page">
          <!-- 划转到 -->
          <div class="transfer-page-side gray-cl">
            {{ transferToOther ? $t("assets.otcAccount.to") : $t("assets.otcAccount.from") }}
          </div>
          <AccountSelect class="transfer-type gray-30-bg" v-model="transferType"></AccountSelect>
        </li>
      </ul>
      <!-- 币种选择 -->
      <OTCCoinSelect
        v-if="transferType === 'otc'"
        style="margin-bottom: 16px;"
        v-model="transferSymbol"
        @change="onSymbolChanged"
        init
      ></OTCCoinSelect>
      <FutureCoinSelect
        v-if="transferType === 'future'"
        style="margin-bottom: 16px;"
        v-model="transferSymbol"
        init
      ></FutureCoinSelect>
      <!-- 划转数量 -->
      <c-inputLine
        name="transferValue"
        :value="transferValue"
        :promptText="$t('assets.otcAccount.volume')"
        :errorHave="true"
        :errorFlag="transferType === 'otc' ? otcTransferError : transferError"
        :errorText="$t('assets.otcAccount.volumeError')"
        :warningText="transferType === 'otc' ? otcTransferWarningText : transferWarningText"
        @onchanges="inputLineChange"
        newStyleFormat
      >
        <!-- 全部 -->
        <c-button
          type="text"
          height="30px"
          @click="transferType === 'otc' ? otcAllTransfer() : allTransfer()"
        >
          {{ $t("assets.otcAccount.all") }}
        </c-button>
      </c-inputLine>
    </section>
  </c-dialog>
</template>

<script>
import { fixD, fixInput, getCoinShowName } from '@/utils';
import OTCCoinSelect from '@/views/components/OTCCoinSelect.vue';
import FutureCoinSelect from '@/views/components/FutureCoinSelect.vue';
import AccountSelect from '@/views/components/widgets/AccountSelect.vue';

export default {
  name: 'CommonTransfer',
  components: {
    OTCCoinSelect,
    FutureCoinSelect,
    AccountSelect,
  },
  data() {
    return {
      transferType: 'otc', // otc 法币划转  future 合约划转
      dialogFlag: false,
      dialogConfirmLoading: false, // 弹窗的确认按钮loading
      otcTransferObj: null, // 当前划转币种的信息
      transferToOther: true, // true 为从现货到其他 false 从其他到现货
      transferValue: '', // 划转数量input
      transferSymbol: '', // 划转的symbol
      // 币币可转
      exchangeAmount: 0,
      // 合约可转
      contractAmount: 0,
    };
  },
  computed: {
    market() {
      return this.$store.state.baseData.market;
    },

    /**
     * otc 弹窗是否可点击
     */
    otcDialogConfirmDisabled() {
      if (this.dialogConfirmLoading) {
        return false;
      }
      let flag = true;
      if (parseFloat(this.transferValue) > 0 && !this.otcTransferError) {
        flag = false;
      }
      return flag;
    },

    /**
     * otc 错误
     */
    otcTransferError() {
      let flag = false;
      // 限制最大数量
      if (this.transferToOther) {
        if (parseFloat(this.transferValue) > parseFloat(this.transferData.exNormal)) {
          flag = true;
        }
      } else if (!this.transferToOther) {
        if (parseFloat(this.transferValue) > parseFloat(this.transferData.otcNormal)) {
          flag = true;
        }
      }
      return flag;
    },

    // input框警示文案
    otcTransferWarningText() {
      const text = this.$t('assets.otcAccount.can'); // 可转
      const { coin, exNormal, otcNormal } = this.transferData;
      const num = this.transferToOther ? exNormal : otcNormal;
      return `${text} ${num} ${this.getShowCoin(coin)}`;
    },

    transferData() {
      let [coin, exNormal, otcNormal] = ['', '--', '--'];
      if (this.otcTransferObj) {
        coin = this.otcTransferObj.coinSymbol;
        const { coinList } = this.market;
        const fix = (coinList[coin] && coinList[coin].showPrecision) || 0;
        // 现货可用
        if (!Number.isNaN(parseFloat(fixD(this.otcTransferObj.exchangeNormal, fix)))) {
          exNormal = fixD(this.otcTransferObj.exchangeNormal, fix);
        }
        // 法币可用
        if (!Number.isNaN(parseFloat(fixD(this.otcTransferObj.normal, fix)))) {
          otcNormal = fixD(this.otcTransferObj.normal, fix);
        }
      }
      return {
        coin,
        exNormal,
        otcNormal,
      };
    },

    // 币种信息
    marginCoinInfor() {
      if (this.$store.state.future.marginCoinInfor) {
        return this.$store.state.future.marginCoinInfor;
      }
      return {};
    },

    // 用户合约资产
    accountBalanceMap() {
      if (this.$store.state.future.futureAccountBalance) {
        return this.$store.state.future.futureAccountBalance;
      }
      return {};
    },

    // 币币资产
    exchangeData() {
      if (this.$store.state.assets.exchangeData) {
        return this.$store.state.assets.exchangeData;
      }
      return null;
    },

    // 币种精度
    showPrecision() {
      if (
        this.marginCoinInfor
        && this.transferSymbol
        && this.marginCoinInfor[this.transferSymbol]
      ) {
        return this.marginCoinInfor[this.transferSymbol].marginCoinPrecision;
      }
      return 4;
    },

    // 限制转入
    fundsInStatus() {
      if (
        this.marginCoinInfor
        && this.transferSymbol
        && this.marginCoinInfor[this.transferSymbol]
      ) {
        return this.marginCoinInfor[this.transferSymbol].fundsInStatus;
      }
      return false;
    },

    // 限制转出
    fundsOutStatus() {
      if (this.marginCoinInfor && this.marginCoinInfor[this.transferSymbol]) {
        return this.marginCoinInfor[this.transferSymbol].fundsOutStatus;
      }
      return false;
    },

    // 弹窗是否可点击
    dialogConfirmDisabled() {
      if (this.dialogConfirmLoading) {
        return false;
      }
      let flag = true;
      if (parseFloat(this.transferValue) > 0 && !this.transferError) {
        flag = false;
      }
      if (this.marginCoinInfor && this.transferSymbol) {
        if (this.transferToOther) {
          if (this.transferSymbol && !this.fundsInStatus) {
            flag = true;
          }
        } else if (!this.transferToOther) {
          if (this.transferSymbol && !this.fundsOutStatus) {
            flag = true;
          }
        }
      }

      return flag;
    },

    // 错误提示
    transferError() {
      let flag = false;
      // 限制最大数量\
      if (this.transferToOther) {
        if (parseFloat(this.transferValue) > parseFloat(this.exchangeAmount)) {
          flag = true;
        }
      } else if (parseFloat(this.transferValue) > parseFloat(this.contractAmount)) {
        flag = true;
      }
      return flag;
    },

    // 划转input框可用文案
    transferWarningText() {
      const text = this.$t('futures.transfer.canTransfer'); // 可转
      let num = 0;
      if (this.marginCoinInfor && this.transferSymbol) {
        num = this.transferToOther
          ? fixD(this.exchangeAmount, this.showPrecision)
          : fixD(this.contractAmount, this.showPrecision);
        return `${text} ${num} ${this.transferSymbol}`;
      }
      return `${text} ${num} ${this.transferSymbol}`;
    },

    // 限制划转
    confirmText() {
      let text = this.$t('futures.transfer.confirm'); // 确定
      if (this.marginCoinInfor && this.transferSymbol) {
        if (this.transferToOther && this.transferSymbol && !this.fundsInStatus) {
          text = this.$t('futures.transfer.cantIn'); // 限制转入
        }
        if (!this.transferToOther && this.transferSymbol && !this.fundsOutStatus) {
          text = this.$t('futures.transfer.cantOut'); // 限制转出
        }
      }
      return text;
    },
  },
  watch: {
    transferValue(v) {
      const { coinList } = this.market;
      const { coin } = this.transferData;
      const fix = (coinList[coin] && coinList[coin].showPrecision) || 0;
      // 限制精度和不非数字字符
      this.transferValue = fixInput(v, fix);
    },

    // 切换币种
    transferSymbol() {
      this.getFutureData();
    },

    // 币币余额
    exchangeData(v) {
      if (v && this.transferSymbol) {
        if (v.allCoinMap[this.transferSymbol] !== undefined) {
          const balance = v.allCoinMap[this.transferSymbol].normal_balance;
          this.exchangeAmount = fixD(balance, this.showPrecision);
        } else {
          this.exchangeAmount = fixD(0, this.showPrecision);
        }
      }
    },
    // 合约余额
    accountBalanceMap(v) {
      if (v && this.transferSymbol && v[this.transferSymbol]) {
        this.contractAmount = v[this.transferSymbol].canTransferAmount;
      }
    },

    transferType() {
      // 划转类型发生变化,默认变成USDT,防止两种划转币种不存在导致问题
      this.transferSymbol = 'USDT';
      this.getFutureData();
    },
  },
  methods: {
    /**
     * 展示划转弹窗
     * @param {*} transferSymbol 币种
     * @param {*} transferToOther 现货转到其他
     * @param {*} transferType 划转类型 otc法币 future合约
     */
    show(transferSymbol = 'USDT', transferToOther = true, transferType = 'otc') {
      this.transferType = transferType;
      this.$nextTick(() => {
        this.transferSymbol = transferSymbol;
        this.transferToOther = transferToOther;
      });
      this.dialogFlag = true;
    },

    getFutureData() {
      if (this.transferType === 'future') {
        this.getData();
      }
    },

    getData() {
      // 请求合约余额
      this.$store.dispatch('getPositionList');
      // 请求币币余额
      this.$store.dispatch('assetsExchangeData');
      // 重置
      this.transferValue = '';
    },

    onSymbolChanged(symbol, symbolObj) {
      this.otcTransferObj = symbolObj;
    },

    getShowCoin(v) {
      let str = v;
      if (this.market && this.market.coinList) {
        str = getCoinShowName(v, this.market.coinList);
      }
      return str;
    },

    // 全部划转
    otcAllTransfer() {
      if (this.transferToOther) {
        if (this.transferData.exNormal === '--') {
          return;
        }
        this.transferValue = this.transferData.exNormal;
      } else {
        if (this.transferData.exNormal === '--') {
          return;
        }
        this.transferValue = this.transferData.otcNormal;
      }
    },

    // 通用
    toCoTransfer() {
      this.dialogConfirmLoading = true;
      this.axios({
        url: 'contract/co_transfer',
        hostType: 'ex',
        params: {
          // wallet_to_contract:币币划转至合约  contract_to_wallet:合约划转至币币
          transferType: this.transferToOther ? 'wallet_to_contract' : 'contract_to_wallet',
          amount: Number(this.transferValue),
          coinSymbol: this.transferSymbol,
        },
        method: 'post',
      }).then((data) => {
        this.dialogConfirmLoading = false;
        if (data.code.toString() === '0') {
          this.$emit('success');
          this.closeDialog();
          this.$bus.$emit('tip', { text: data.msg, type: 'success' });
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      }).catch(() => {
        this.dialogConfirmLoading = false;
      });
    },

    allTransfer() {
      if (this.transferToOther) {
        if (this.exchangeAmount === null) {
          return;
        }
        this.transferValue = this.exchangeAmount.toString();
      } else {
        if (!this.contractAmount) {
          return;
        }
        this.transferValue = this.contractAmount.toString();
      }
    },

    // 修改划转方向
    setTransferSide() {
      this.transferToOther = !this.transferToOther;
      this.transferValue = ''; // 重置划转数量
    },

    inputLineChange(value, name) {
      this[name] = value;
    },

    dialogClose() {
      this.transferToOther = true; // 重置划转方向
      this.transferValue = ''; // 重置划转数量
      this.otcTransferObj = null; // 重置划转对象
      this.dialogFlag = false; // 关闭弹窗
    },

    dialogConfirm() {
      this.toCoTransfer();
    },

    closeDialog() {
      this.dialogFlag = false;
    },

    otcDialogConfirm() {
      this.dialogConfirmLoading = true;
      this.axios({
        url: 'finance/otc_transfer',
        params: {
          fromAccount: this.transferToOther ? '1' : '2',
          toAccount: this.transferToOther ? '2' : '1',
          amount: this.transferValue,
          coinSymbol: this.transferSymbol,
        },
        method: 'post',
      }).then((data) => {
        this.dialogConfirmLoading = false;
        if (data.code.toString() === '0') {
          this.$emit('success');
          this.closeDialog();
          this.$bus.$emit('tip', { text: data.msg, type: 'success' });
          this.transferToOther = true; // 重置划转方向
          this.transferValue = ''; // 重置划转数量
          this.otcTransferObj = null; // 重置划转对象
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      }).catch(() => {
        this.dialogConfirmLoading = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.transfer-box {
  .transfer-content {
    margin-bottom: 16px;
    user-select: none;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.reverse {
      flex-direction: row-reverse;
    }

    .transfer-page {
      flex: 1;
      // padding-left: 16px;
    }

    .transfer-page-side {
      font-size: 12px;
      line-height: 16px;
      margin-top: 13px;
    }

    .transfer-page-name {
      font-size: 12px;
      border-radius: 4px;
      height: 40px;
      line-height: 40px;
      margin-top: 6px;
      padding: 0 16px;
    }

    .transfer-type {
      margin-top: 6px;
      border-radius: 4px !important;

      /deep/ .input-content {
        font-size: 12px !important;
      }
    }

    .transfer-icon {
      text-align: center;
      font-size: 16px;
      cursor: pointer;
      margin: 32px 8px 0;
    }
  }
}
</style>
